export default "__VITE_ASSET__DHzFgzKH__"